export interface FormValidations {
  type: FormValidationTypes;
  message: string;
}

export type FormValidationTypes =
  | FormValidationsDictionary.Required
  | FormValidationsDictionary.MinLength
  | FormValidationsDictionary.MaxLength
  | FormValidationsDictionary.RequiredLength
  | FormValidationsDictionary.OnlyNumbers;

export enum FormValidationsDictionary {
  Required = 'required',
  OnlyNumbers = 'onlyNumbers',
  MinLength = 'minlength',
  MaxLength = 'maxlength',
  RequiredLength = 'requiredLength',
}
